import { usePathname } from 'next/navigation'
import { FEATURE_FLAGS, FeatureFlagRoute } from '@scalis/feature-flags'
import { Routes } from '@scalis/routes'
import { RoleEnum } from '~/bff/graphql/generated/graphql'
import { RequireRole } from '~/hooks/use-has-permissions'
import {
  AnalyticsIcon,
  CalendarIcon,
  DashboardIcon,
  Divider,
  ReferralsIcon,
  ReportsIcon,
  TalentDatabaseIcon,
} from '~/scalis-components/core'
import { Aside } from '../aside'

interface ATSProps {
  showContent: boolean
}

export const ATS = ({ showContent }: ATSProps) => {
  const pathname = usePathname()
  return (
    <>
      <Aside.List>
        {showContent && (
          <FeatureFlagRoute
            featureFlag={FEATURE_FLAGS.CRM}
            redirect={false}
          >
            <span className='body-small-basic text-neutral-secondary pl-1'>ATS</span>
          </FeatureFlagRoute>
        )}
        <Aside.Item
          label='Job Dashboard'
          href={Routes.company.active}
          icon={DashboardIcon}
          active={pathname?.includes(Routes.company.active)}
          showContent={showContent}
        />
        {
          <Aside.Item
            label='Calendar'
            href={Routes.company.calendar}
            icon={CalendarIcon}
            active={pathname?.includes(Routes.company.calendar)}
            showContent={showContent}
          />
        }
        <Aside.Item
          label='Talent Database'
          href={Routes.company.talent_database({ talentPoolId: undefined })}
          icon={TalentDatabaseIcon}
          active={pathname?.includes(Routes.company.talent_database({ talentPoolId: undefined }))}
          showContent={showContent}
        />
        <RequireRole requiredRoles={[RoleEnum.Admin, RoleEnum.SuperAdmin]}>
          <Aside.Item
            label='Analytics'
            href={Routes.company.analytics}
            active={pathname?.includes(Routes.company.analytics)}
            icon={AnalyticsIcon}
            showContent={showContent}
          />
        </RequireRole>
        <Aside.Item
          label='Reports'
          href={Routes.company.reports}
          active={pathname?.includes(Routes.company.reports)}
          icon={() => <ReportsIcon notification={true} />}
          showContent={showContent}
        />
        <Aside.Item
          label='Referrals'
          href={Routes.company.referrals}
          active={pathname?.includes(Routes.company.referrals)}
          icon={ReferralsIcon}
          showContent={showContent}
        />
      </Aside.List>
      <Divider />
    </>
  )
}
